import type {
  ListProductCardsResponse,
  ProductCardSortBy,
} from "@/types/ingestedProduct";
import type {
  UseInfiniteQueryResult,
  InfiniteData,
} from "@tanstack/react-query";

import { useInfiniteListProductCards } from "@/api/products";
import {
  taxonomyFilterForCollection,
  type SKUStoreCollection,
} from "@/features/SKUStore/collections/skuStoreCollections";

/**
 * Product cards for a SKU Store collection. Shared by the Products and Media
 * tabs so both read one query: the banner's product total must match the
 * "Products (N)" heading, and a shared key keeps the second tab a cache hit.
 *
 * `sortBy` only applies on the Products tab; unsorted, the key is identical
 * to the Media tab's, so the cache is shared.
 */
export function useCollectionProductCards(
  siteId: string,
  collection: SKUStoreCollection,
  sortBy?: ProductCardSortBy,
): UseInfiniteQueryResult<InfiniteData<ListProductCardsResponse>, Error> {
  return useInfiniteListProductCards(siteId, {
    filter: taxonomyFilterForCollection(collection),
    sortBy,
  });
}
